
export const MEASUREMENT_UNIT_CHANGED = 'measurementUnit:changed';



// WEBPACK FOOTER //
// ./assets/js/global/constants/measurementUnitActionConstants.es.js